import { Switch } from 'govbr.frontend.policy/components';
import { injectIntl } from 'react-intl';

import { buttons } from '../../../../messages';

import styles from './Group.module.less';

const Group = ({
  intl,
  title,
  children,
  readonly = false,
  checked,
  handleChange,
}) => {
  return (
    <div className={`${styles.root} mb-2x`}>
      <div>
        <Switch
          readonly={readonly}
          checked={checked}
          icon
          label={title}
          data-on={intl.formatMessage(buttons.CookieGroupOn)}
          data-off={intl.formatMessage(buttons.CookieGroupOff)}
          label-hidden
          handleChange={handleChange}
          dataClassName="text-weight-regular"
          labelClassName="text-weight-semi-bold"
        />
      </div>
      <div className="mt-base">{children}</div>
    </div>
  );
};

export default injectIntl(Group);
